import React, {Component} from 'react';
import { Box, Center, Heading, Image, Text } from '@chakra-ui/react';

import Logo from "./img/logo.png";
import Background from "./img/sfondohome.png";
import { Container } from '@chakra-ui/react';
import Titolo from "./img/titolohome.png";

import Navbar from "./components/navbar";


export default class Mint extends Component {
  render() {
    return (
      <>
            <div className='container-fluid' style={{backgroundImage: "url(" + Background + ")", backgroundRepeat: "no-repeat", backgroundSize: "1920px", height: "1080px", weight: "1920px"}}>                
                <Navbar 
                img={Logo}
                color="#ffffff"/>
                <Center p={6}>
                  <Image src={Titolo} width='900px'/>
                </Center>
                <Center p={9}>
                  <Heading fontSize='37px' style={{fontFamily:"Roboto", color: "#ffffff"}} >FOLKLORE E SERVIZI DIGITALI PER IL WEB 3</Heading>
                </Center>
                <Center>
                  <Box w='100%'>
                      <Text fontSize='25px' style={{fontFamily:"Roboto", color: "#ffffff"}}> Per tutti gli appassionati del folklore italiano e delle innovazioni legate alla blockchain che hanno il bisogno di fare il loro primo passo nel </Text>
                      <Text fontSize='25px' style={{fontFamily:"Roboto", color: "#ffffff"}}> web3, la Carnival Society è un brand che offre servizi digitali per questo ambito. Mette a disposizione una community e una vetrina che permettono di far emergere i prodotti in un mercato più interoperativo e interattivo rispetto al tradizionale.</Text>
                  </Box>
                </Center>
            </div>       
          
      </>
    );
  }
}
